import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useLanguage } from '../i18n/LanguageContext';

const LanguageSwitcher = ({ placement = 'nav' }) => {
  const { currentLanguage, languages, setLanguage, t } = useLanguage();
  const isDashboard = placement === 'dashboard';

  return (
    <Dropdown className={`language-switcher language-switcher-${placement}`} align="end">
      <Dropdown.Toggle
        variant="light"
        className="language-switcher-toggle"
        aria-label={t.language.changeLanguage}
      >
        <span className="language-switcher-flag">
          {isDashboard ? currentLanguage.avatarFlag : currentLanguage.flag}
        </span>
        {!isDashboard && <span className="language-switcher-code">{currentLanguage.shortLabel}</span>}
      </Dropdown.Toggle>
      <Dropdown.Menu className="language-switcher-menu">
        {languages.map((item) => (
          <Dropdown.Item
            key={item.code}
            active={item.code === currentLanguage.code}
            onClick={() => setLanguage(item.code)}
          >
            <span className="language-switcher-flag">{item.flag}</span>
            <span>{item.label}</span>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguageSwitcher;
